/**
 * @description 公共模块
 */
import { getSemester, getCollege, getRole, setRole, getUserInfo, logout, refreshToken } from '@/api/commom'

const state = () => ({
  userInfo: {},
  token: '',
  roleList: [],
})

const getters = {}
// 同步方法写在这里--对应commit
const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data
  },
  setToken(state, data) {
    state.token = data
  },
  setRoleList(state, data) {
    state.roleList = data
  },
}
// 异步请求写在这里--对应dispatch
const actions = {
  // 获取学期列表
  getSemester({}, data) {
    return new Promise((resolve, reject) => {
      getSemester(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取学院列表
  getCollege({}, data) {
    return new Promise((resolve, reject) => {
      getCollege(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取角色列表
  getRole({}, data) {
    return new Promise((resolve, reject) => {
      getRole(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 切换角色
  setRole({}, data) {
    return new Promise((resolve, reject) => {
      setRole(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取用户信息
  getUserInfo({}, data) {
    return new Promise((resolve, reject) => {
      getUserInfo(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 退出登录
  logout({}, data) {
    return new Promise((resolve, reject) => {
      logout(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取新token
  refreshToken({}, data) {
    return new Promise((resolve, reject) => {
      refreshToken(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

export default { state, getters, mutations, actions }
